export const formatRupiah = (n) =>
  new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(n);

export const formatNumber = (n) =>
  new Intl.NumberFormat('id-ID').format(n);

export const formatDate = (d) =>
  new Date(d).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });

export const formatDatetime = (d) =>
  new Date(d).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const statusColors = {
  AKTIF:              { bg: '#ECFDF5', text: '#065F46', border: '#A7F3D0' },
  DRAFT:              { bg: '#F3F4F6', text: '#374151', border: '#D1D5DB' },
  PENDING_VERIFIKASI: { bg: '#FEF3C7', text: '#92400E', border: '#FCD34D' },
  PENDING_APPROVAL:   { bg: '#FFF7ED', text: '#9A3412', border: '#FDBA74' },
  DISETUJUI:          { bg: '#ECFDF5', text: '#065F46', border: '#A7F3D0' },
  DITOLAK:            { bg: '#FEF2F2', text: '#991B1B', border: '#FECACA' },
  SELESAI:            { bg: '#EFF6FF', text: '#1E40AF', border: '#BFDBFE' },
  TERPOSTING:         { bg: '#EFF6FF', text: '#1E40AF', border: '#BFDBFE' },
  PENERIMAAN:         { bg: '#ECFDF5', text: '#065F46', border: '#A7F3D0' },
  PENGELUARAN:        { bg: '#FEF2F2', text: '#991B1B', border: '#FECACA' },
  PAYMENT_REQUEST:    { bg: '#FEF3C7', text: '#92400E', border: '#FCD34D' },
};

export const statusLabel = {
  PENDING_VERIFIKASI: 'Menunggu Verifikasi',
  PENDING_APPROVAL:   'Menunggu Persetujuan',
  DISETUJUI:          'Disetujui',
  DITOLAK:            'Ditolak',
  SELESAI:            'Selesai',
  TERPOSTING:         'Terposting',
  DRAFT:              'Draft',
  AKTIF:              'Aktif',
};

export const roleLabel = {
  ADMIN:       'Administrator',
  BENDAHARA:   'Bendahara',
  PEJABAT:     'Pejabat (PPK)',
  EKSEKUTIF:   'Eksekutif',
  VERIFIKATOR: 'Verifikator',
};

export const fmtRp = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n);
export const fmtDate = (d) => new Date(d).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });

export const statusConfig = {
  PENDING_VERIFIKASI: { label: "Menunggu Verifikasi",  color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  PENDING_APPROVAL:   { label: "Menunggu Persetujuan", color: "#EA580C", bg: "#FFF7ED", border: "#FDBA74" },
  DISETUJUI:          { label: "Disetujui",            color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  DITOLAK:            { label: "Ditolak",              color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  SELESAI:            { label: "Selesai",              color: "#1D4ED8", bg: "#EFF6FF", border: "#93C5FD" },
  TERPOSTING:         { label: "Terposting",           color: "#1D4ED8", bg: "#EFF6FF", border: "#93C5FD" },
  DRAFT:              { label: "Draft",                color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  AKTIF:              { label: "Aktif",                color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  NONAKTIF:           { label: "Nonaktif",             color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  PENERIMAAN:         { label: "Penerimaan",           color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  PENGELUARAN:        { label: "Pengeluaran",          color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  PAYMENT_REQUEST:    { label: "Payment Request",      color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
};
